import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pt-BR',
  months: [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ],
  monthsShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  weekdays: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
  weekdaysMin: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  weekdaysShort: ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sáb.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD-MM-YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D [de] MMMM',
    LLL: 'D [de] MMMM [de] YYYY, HH:mm',
    'LLL-Y': 'D [de] MMMM, HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY, HH:mm',
    'LLLL-Y': 'dddd, D [de] MMMM, HH:mm',
    l: 'D-M-YYYY',
    'l-Y': 'D-M',
    ll: 'D [de] MMM [de] YYYY',
    'll-Y': 'D [de] MMM',
    lll: 'D [de] MMM [de] YYYY, HH:mm',
    'lll-Y': 'D [de] MMM, HH:mm',
    llll: 'ddd, D [de] MMM [de] YYYY, HH:mm',
    'llll-Y': 'ddd, D [de] MMM, HH:mm',
    'll-Y+w': 'ddd, D [de] MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D [de] MMMM [de] YYYY HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'há %s ano', other: 'há %s anos' },
    M: { one: 'há %s mês', other: 'há %s meses' },
    w: { one: 'há %s sem.', other: 'há %s sem.' },
    d: { one: 'há %s dia', other: 'há %s dias' },
    h: { one: 'há %s h', other: 'há %s h' },
    m: { one: 'há %s min.', other: 'há %s min.' },
    s: { one: 'há %s seg.', other: 'há %s seg.' },
  },
  future: {
    y: { one: 'em %s ano', other: 'em %s anos' },
    M: { one: 'em %s mês', other: 'em %s meses' },
    w: { one: 'em %s sem.', other: 'em %s sem.' },
    d: { one: 'em %s dia', other: 'em %s dias' },
    h: { one: 'em %s h', other: 'em %s h' },
    m: { one: 'em %s min.', other: 'em %s min.' },
    s: { one: 'em %s seg.', other: 'em %s seg.' },
  },
  abbr: {
    y: { one: '%s ano', other: '%s anos' },
    M: { one: '%sm', other: '%sm' },
    w: { one: '%s sem.', other: '%s sem.' },
    d: { one: '%sd', other: '%sd' },
    h: { one: '%sh', other: '%sh' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%ss', other: '%ss' },
  },
  justNow: 'Agora mesmo',
  yesterday: 'Ontem',
  today: 'Hoje',
  tomorrow: 'Amanhã',
};
const localeName: LocaleName = 'pt-BR';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
